import { __decorate } from "tslib";
import { Component } from '@angular/core';
let FinishedBlinkingPhaseTwoComponent = class FinishedBlinkingPhaseTwoComponent {
    constructor() {
    }
    ngOnInit() {
    }
};
FinishedBlinkingPhaseTwoComponent = __decorate([
    Component({
        selector: 'ecd-finished-blinking-phase-two',
        template: __importDefault(require("./finished-blinking-phase-two.component.html")).default,
    })
], FinishedBlinkingPhaseTwoComponent);
export { FinishedBlinkingPhaseTwoComponent };
